export const NOTE_MAX_LENGTH_DEFAULT = 150;
export const NOTE_MIN_LENGTH = 2;
export const NOTE_VALIDATION_ERROR_MESSAGE = 'Catatan minimal 2 karakter';

/**
 * Validates that a trimmed cart note meets requirements: empty is allowed (to clear),
 * otherwise minimum 2 characters, not hyphen-only, and not space-only.
 */
export function isValidCartNote(trimmed: string): boolean {
  if (trimmed === '') return true;
  if (trimmed.length < NOTE_MIN_LENGTH) return false;
  if (/^-+$/.test(trimmed)) return false;
  if (/^ +$/.test(trimmed)) return false;
  return true;
}

/**
 * Sanitize free-text note input by removing control characters and
 * truncating by Unicode code points to a safe maximum length.
 */
export function sanitizeNote(
  input: string,
  max: number = NOTE_MAX_LENGTH_DEFAULT
): string {
  // Remove all Unicode control characters (category Cc)
  const withoutControls = input.replace(/\p{Cc}/gu, '');
  // Truncate by code points to avoid breaking surrogate pairs
  const codepoints = Array.from(withoutControls);
  return codepoints.slice(0, max).join('');
}
